import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "NotebookReference"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M3 3.75H21C21.8281 3.75083 22.4992 4.42192 22.5 5.25V18.75C22.4992 19.5781 21.8281 20.2492 21 20.25H11.25V5.25H3V12.75H1.5V5.25C1.50083 4.42192 2.17192 3.75083 3 3.75ZM12.75 5.25V18.75H21.0015L21 5.25H12.75ZM3 15V16.5H5.6895L1.5 20.6895L2.5605 21.75L6.75 17.5605V20.25H8.25V15H3ZM19.5 7.5H14.25V9H19.5V7.5ZM14.25 11.25H19.5V12.75H14.25V11.25ZM19.5 15H14.25V16.5H19.5V15Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/NotebookReference.vue"]]);
